export const FetchState = {

    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    LOADING: "LOADING"
}

export default FetchState;